import { useQuery } from '@tanstack/react-query'
import { getCharterOffersLaunchOfferPromotionAvailableSeats } from 'api/flights'

const CHARTER_PROMOTION_AVAILABLE_SEATS_STALE_TIME_MS = 60 * 1000

interface UseCharterFlightPromotionAvailableSeatsParams {
  enabled?: boolean
}

interface UseCharterFlightPromotionAvailableSeatsResult {
  availableSeats: number
  isLoading: boolean
  error: unknown
}

export default function useCharterFlightPromotionAvailableSeats(params: UseCharterFlightPromotionAvailableSeatsParams = {}): UseCharterFlightPromotionAvailableSeatsResult {
  const {
    enabled = true,
  } = params

  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: ['charterFlightPromotionAvailableSeats', 'offers-launch-offer'],
    queryFn: getCharterOffersLaunchOfferPromotionAvailableSeats,
    enabled,
    staleTime: CHARTER_PROMOTION_AVAILABLE_SEATS_STALE_TIME_MS,
  })

  return {
    availableSeats: data?.seatsLeft ?? 0,
    isLoading: isLoading || isFetching,
    error,
  }
}
